// angular
import {Component, ɵConsole, AfterViewInit, ElementRef, OnInit} from '@angular/core';
import {AppService} from "../../app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { SelfEvaluationService } from '../self-evaluation.service';
import set = Reflect.set;
import { AuthService } from '../../core/auth.service';
import { CoreService } from '../../core/core.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectionComponent } from '../selection.component';

// others
declare var window:any;

@Component({
    templateUrl: 'continue-later.component.html',
    styleUrls: ['../self-evaluation.component.scss']
})
export class ContinueLaterComponent extends SelectionComponent implements AfterViewInit {
    token = '';
    hide = true;
    deviceInnerHeight: number;

    constructor(
        public appService: AppService,
        public router: Router,
        public service: SelfEvaluationService,
        public route : ActivatedRoute,
        public authService: AuthService,
        public coreService: CoreService,
        public translateService : TranslateService,
        public elementRef: ElementRef,
    ) {
        super(elementRef, service, router, route, authService, appService, coreService, translateService);
    }

    ngOnInit() {
        this.noBackPlease();
        this.route.params.subscribe(params => {
            this.token = params.token;
        });
    }

    ngAfterViewInit() {
        setTimeout ( () => {
            this.hide = false;
            this.scrollToTop();
        },100);
    }

    scrollToTop() {
        var scrollStep = -window.scrollY / (500 / 15),
            scrollInterval = setInterval(function(){
                if ( window.scrollY != 0 ) {
                    window.scrollBy( 0, scrollStep );
                }
                else clearInterval(scrollInterval);
            },15);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.deviceInnerHeight = this.appService.isMobile ? window.innerHeight : 0;
    }

    noBackPlease() {
        //Fix error on safari
        history.pushState(null, document.title, location.href);
        window.onpopstate = function () {
            history.pushState(null, document.title, location.href);
        };
    };

    backToSEPage() {
        this.service.isRedirectedFromAmnestic = false;
        this.router.navigate([this.pageTypes[this.appService.SEType]['route'] + '/' + this.token])
    }
}
